<template>
  <div class="content-container">
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :context="context"
        :auto-size-cell="true"
        :columns="columns"
        :rows="rows"
        class="agGrid"
      />
    </div>
    <!-- <el-col class="bottom-btns-container">
      <el-button type="primary" @click="dialogFormVisible = true">
        Thêm mẫu
      </el-button>
      <el-button type="primary" @click="onEditItem">
        Sửa mẫu
      </el-button>
      <el-button type="danger" @click="onDeleteItem">
        Xóa mẫu
      </el-button>
    </el-col> -->
    <div class="button-containers mb-0">
      <button class="btn primary small outline" @click="onDeleteItem">
        {{ $t('button.delete') }}
      </button>
      <button class="btn primary small" @click="onEditItem">
        {{ $t('button.modify') }}
      </button>
      <button class="btn primary small" @click="dialogFormVisible = true">
        {{ $t('button.add') }}
      </button>
    </div>
    <el-dialog
      :title="
        isEdit
          ? this.$t('dialog.customerProfileUpdate')
          : this.$t('dialog.customerProfileAdd')
      "
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
      width="600px"
    >
      <validation-observer ref="formValidator">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <validation-provider rules="required|max:20" name="Tiêu đề">
                  <div class="das-form-input">
                    <div class="label required">Tiêu đề:</div>
                    <div class="child-w-80">
                      <input
                        v-model="templateItem.title"
                        type="text"
                        :readonly="isEdit"
                      />
                    </div>
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="label">Tác vụ đi kèm</div>
                  <div class="checkbox-container">
                    <div class="checks-wrap">
                      <input
                        id="adasdvzx"
                        v-model="templateItem.type"
                        type="radio"
                        :value="0"
                      />
                      <label for="adasdvzx">Khi nhận phòng</label>
                    </div>
                    <div class="checks-wrap ml-10">
                      <input
                        id="adasdvzx2"
                        v-model="templateItem.type"
                        type="radio"
                        :value="1"
                      />
                      <label for="adasdvzx2">Khi xem giao dịch</label>
                    </div>
                    <div class="checks-wrap ml-10">
                      <input
                        id="adasdvzx3"
                        v-model="templateItem.type"
                        type="radio"
                        :value="2"
                      />
                      <label for="adasdvzx3">Khi xem chi tiết nhận phòng</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
      <!-- <el-form>
        <el-form-item label="Loại giao dịch">
          <el-radio v-model="templateItem.type" :label="1">Sở thích</el-radio>
          <el-radio v-model="templateItem.type" :label="2">Sự kiện</el-radio>
          <el-radio v-model="templateItem.type" :label="3">Khác</el-radio>
        </el-form-item>
        <el-form-item label="Tiêu đề">
          <el-input v-model="templateItem.title" placeholder="Nhập thông tin" />
        </el-form-item>
      </el-form> -->
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button v-if="isEdit" class="btn primary small" @click="updateItem">
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small" @click="addItem">
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { CellRenderCheckbox } from '@/utils/cellRenders.js'
import {
  getListGuestTemplate,
  addGuestTemplate,
  updateGuestTemplate,
  deleteGuestTemplate
} from '@/api/configuration/general/guestTemplate.js'
export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    CellRenderCheckbox
  },
  data() {
    return {
      loading: false,
      searchParams: {
        pageSize: 10,
        pageNum: 1,
        orderTp: 'ASC'
      },
      dialogFormVisible: false,
      templateItem: {
        id: null,
        title: '',
        type: 1
      },
      context: null,
      options: [
        {
          value: '1',
          label: 'Bảng Group/ Group Master Search'
        },
        {
          value: 'Option2',
          label: 'Option2'
        },
        {
          value: 'Option3',
          label: 'Option3'
        },
        {
          value: 'Option4',
          label: 'Option4'
        },
        {
          value: 'Option5',
          label: 'Option5'
        }
      ],
      value: '',
      isEdit: false,
      columns: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: 'Loại ghi chú',
          field: 'type',
          width: 100
        },
        {
          headerName: 'Tiêu đề',
          field: 'title'
        }
      ],
      rows: []
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetInfo()
    }
  },
  beforeMount() {
    this.context = { componentParent: this }
  },
  mounted() {
    this.attachData()
  },
  methods: {
    async addItem() {
      // eslint-disable-next-line eqeqeq
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false) {
        return
      }
      await addGuestTemplate(this.templateItem)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    onEditItem() {
      const gridApi = this.$refs.agGrid.gridApi
      const row = gridApi.getSelectedRows()[0]
      if (!row) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
      } else {
        this.templateItem.id = row.id
        Object.assign(this.templateItem, row)
        this.dialogFormVisible = true
        this.isEdit = true
      }
    },
    async updateItem() {
      // eslint-disable-next-line eqeqeq
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false) {
        return
      }
      await updateGuestTemplate(this.templateItem)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async onDeleteItem() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      const id_list = rowsSelected.map(item => item.id)
      if (id_list.length === 0) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
      } else {
        this.$vxConfirm(this.$t('alert.deleteCustomerProfileConfirm'), () => {
          deleteGuestTemplate({
            id_list: id_list
          })
            .then(async res => {
              const message = res.message
              await this.attachData()
              this.dialogFormVisible = false
              this.$message({
                type: 'success',
                message: this.$t(`successMsg.${message}`)
              })
            })
            .catch(error => {
              const message = error.response?.data?.message || 'default'
              this.$message({
                type: 'error',
                message: this.$t(`errorMsg.${message}`)
              })
            })
        })
      }
    },
    resetInfo() {
      this.isEdit = false
      this.templateItem = {
        id: null,
        title: '',
        type: 1
      }
    },
    async attachData() {
      // bus.$emit('startLoader', { msg: '' })
      this.loading = true
      const data = await getListGuestTemplate(this.searchParams)
      // bus.$emit('endLoader')
      this.loading = false
      this.rows = data.data
    }
  }
}
</script>

<style lang="scss">
.table-container {
  margin: 10px 0;
}
</style>
